<template>
  <section class="content-section primary">
    <div class="section-title">
        <!-- <div class="section-title-line"></div> -->
        <h1>EINGANGSBEREICHE - DIE VISITENKARTE IHRES HAUSES</h1>
       <!--  <div class="section-title-line"></div> -->
    </div>
    <div class="container">
      <article class="detailed-info">
        <p>Der Eingangsbereich eines Gebäudes muss ganz schön viel herhalten. So wird er doch mit den unterschiedlichsten Schuhwerken und Absatzformen bei Wind und Wetter über die Jahre hin tausendfach betreten, muss Feuchtigkeit und Schmutz trotzen und soll dabei auch noch schick aussehen. Das auch in diesem Bereich Treppen und Podeste aus Naturstein immer häufiger zum Einsatz kommen, verwundert uns nicht. Denn neben allem Komfort, der Wetterbeständigkeit und bestmöglicher Sicherheit, bieten Eingangsbereiche aus Naturstein auch einen echten Blickfang.</p>
        <hr>
        <h2>Schließlich zählt nichts so sehr wie ein stilsicherer, erster Eindruck!</h2>
        <p>Sorgen Sie durch den Einsatz von Naturstein im Eingangsbereich bei Ihren Besuchern direkt von Beginn an für ein positives Empfinden! Denn Naturstein wirkt hochwertig, edel und strahlt gleichzeitig durch seine einzigartige Strukturierung und Farbtöne Natürlichkeit aus. Im Gegensatz zu Klinker oder Fliesen, ist ein Podest oder eine Treppe aus Naturstein im Eingangsbereich zudem wesentlich witterungsbeständiger, robuster und langlebiger. Durch das geringe Fugenbild kann weniger Feuchtigkeit eindringen, wodurch typische Schadensbilder, wie offene und ausblühende Fugen und andere sichtbare Spuren, wie Materialverwitterung der Vergangenheit angehören.</p>
        <hr>
        <div class="image-row">
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/portfolio/eingang/eingang10.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/portfolio/eingang/eingang03.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/portfolio/eingang/eingang04.jpg"></div>
        </div>
        <hr>
        <h2>Absolute Gestaltungsfreiheit mit vielen Natursteinarten und Farben </h2>
        <p>Im Idealfall verbindet sich die Gestaltung des Eingangsbereiches, die Einfahrt und die Architektur zu einem harmonischen Gesamtbild. Aber natürlich nehmen wir auch Ihre eigenen Vorlieben und Wünsche mit auf und <router-link :to="{ name: 'Kontakt' }">beraten Sie darüber hinaus fachmännisch bei der Planung</router-link> und der Auswahl des passenden Natursteins für Ihren neuen Eingangsbereich. Als Fachbetrieb greifen wir auf über 50 Jahre Erfahrung zurück und können so für die Sicherheit Ihrer Treppe garantieren und ihrem Eingangsbereich eine unverkennbare Optik verleihen.</p>
      </article>
    </div>
    <hr>
    <div class="image-row">
       <div class="image-row-item"><img src="https://marmor-kunze.de/static/portfolio/eingang/eingang07.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/portfolio/eingang/eingang08.jpg"></div>
      <div class="image-row-item"><img src="https://marmor-kunze.de/static/portfolio/eingang/eingang05.jpg"></div>
    </div>
    </section>
</template>

<script>
export default {
  name: 'Eingangsbereiche',
   metaInfo: {
    title: 'Eingangsbereiche aus Naturstein',
    meta:[
      { vmid: 'description', name: 'description', content: "Sorgen Sie durch den Einsatz von Naturstein im Eingangsbereich bei Ihren Besuchern direkt von Beginn an für ein positives Empfinden"},
      { vmid: 'keywords', name: 'keywords', content: "Naturstein Eingangsbereich, Naturstein Podest, Natursteintreppe, Naturstein Eingang, Eingangsbereich aus Naturstein, Naturstein Mönchengladbach"},
      
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/naturstein-eingangsbereich'} ]
  },
 
}
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/Eingangsbereich.vue